import React from 'react';
import { AppIcon } from '../../../../components/icons/AppIcon';

export const ChatEmptyState: React.FC = () => (
    <div className="flex-1 flex items-center justify-center bg-surface text-secondary">
        <div className="text-center">
            <div className="w-20 h-20 bg-surface-subtle rounded-full flex items-center justify-center mx-auto mb-4">
                <AppIcon name="message" className="w-10 h-10 text-caption" />
            </div>
            <p className="text-lg font-medium text-default">Nenhuma conversa selecionada</p>
            <p className="text-sm mt-2 text-secondary">Selecione uma conversa para começar o atendimento.</p>
        </div>
    </div>
);
